<template>
  <v-container>
    <helmet-provider>
      <div>
        <helmet>
          <title>HighFleet 日本語化 - 日本語化ファイル置き場 -</title>
          <meta name='description' content='Steamで配信中の飛行船ストラテジーACTゲーム、"HighFleet"の日本語化に関するページです。'>
          <meta property='og:title' content='日本語化ファイル置き場'/>
          <meta property='og:description' content='Steamで配信中の飛行船ストラテジーACTゲーム、"HighFleet"の日本語化に関するページです。'/>
          <meta property='og:image' content='https://storage.googleapis.com/porte-parapluies.appspot.com/Highfleet/005s.webp'/>
          <meta property='og:url' content='https://porte-parapluies.web.app/games/highfleet/'/>
          <meta property='og:type' content='website'/>
        </helmet>
      </div>
    </helmet-provider>
    <page-title 
      title='HighFleet 日本語化'
      link='https://porte-parapluies.web.app/games/highfleet/'/>
    <game-info 
      gameName='HighFleet' 
      gameLink='https://store.steampowered.com/app/1434950/HighFleet/' 
      makerName='Konstantin Koshutin' />
    <page-contents
      :contents=pageInfo />
    <page-contents
      title="ゲームの内容"
      :contents=contents />
    <list-contents
      title="Modについて"
      :contents=about />
    <list-contents
      title="日本語Mod導入手順"
      :contents=guides />
    <game-image 
      title="日本語Mod適用後のイメージ"
      path="Highfleet"
      :images=images />
  </v-container>
</template>

<script>
import { HelmetProvider, Helmet } from "@jnields/vue-helmet";

import PageTitle from '@/components/PageTitle.vue'
import PageContents from '@/components/PageContents.vue'
import GameInfo from '@/components/GameInfo.vue'
import GameImage from '@/components/GameImage.vue'
import ListContents from '@/components/ListContents.vue'

export default {
  components: {
    PageTitle,
    PageContents,
    GameInfo,
    GameImage,
    HelmetProvider, 
    Helmet,
    ListContents
  },
  data(){
    return{
      contents:[
        'Highfleetは、荒廃した世界を飛行船の船団を指揮し都市を攻略していく、飛行船ストラテジーACTゲームです。'
      ],
      guides:[
        '日本語化ModはGoogleドライブに置いてあります。<a href="https://drive.google.com/drive/folders/1uUMPvvUlYjWmblbnijG0ByIUB7kIeWGz?usp=sharing" target="_blank">こちら</a>からダウンロードして中のreadme.txtの手順に従って導入してください。'
      ],
      about:[
        'バージョン1.163(2024年2月26日時点での最新版)向けです。',
        '会話シーンやイベントシーンを中心に日本語化しています。',
        '同一の文言が複数個所で使われておりフォントや色の都合上見づらかったり、イベントシーンでのカードの傾きに対応出来ないため見づらかったりする箇所があります。',
        '他の日本語化関連のMod、<a href="https://www.nexusmods.com/highfleet/mods/8" target="_blank">Highfleet VoiceVox MOD</a>や<a href="https://www.nexusmods.com/highfleet/mods/39" target="_blank">Highfleet Vanilla simple Japanese Mod</a>とも競合していないので、同時に導入出来るはずです。'
      ],
      images:[
        {
          alt:'幕間',
          overlay: false
        },
        {
          alt:'会話シーン',
          overlay: false
        },
        {
          alt:'勧誘',
          overlay: false
        },
        {
          alt:'イベント',
          overlay: false
        }
      ],
    }
  }
};
</script>
